<template>
  <div style="padding:10px; margin:0 auto; width:100%">
    <v-container justify-center style="width:100%;">
      <v-row>
        <v-col cols="12">
          <div class="select is-small">
            <select class="schedule-host-dropdown" @change="setSession">
              <option
                  :selected="null"
                  value=""
              >
                Choose Session
              </option>
              <option
                  v-for="n in countStime(game)"
              >
                Session {{ n }}
              </option>
            </select>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="select is-small">
            <select v-model="selectedHost" class="schedule-host-dropdown">
              <option
                  :selected="null"
                  value=""
              >
                Choose Host
              </option>
              <option
                  v-for="host in fetchedHosts"
                  :value="{hostId: host.id, venueId: game.venueid, calId: game.id, session: session, gameDate: game.date}"
              >
                {{ fullName(host.first, host.last) }}
              </option>
            </select>
          </div>
        </v-col>
      </v-row>
        <v-row>
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="setHost"
                       v-bind="attrs"
                       v-on="on"
                       small>
                  <v-icon style="font-size:16px;font-weight:bold">
                    fal fa-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
          <v-col v-if="!game.gameDate">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="makeDefault"
                       v-bind="attrs"
                       v-on="on"
                       small>
                  <v-icon style="font-size:16px;font-weight:bold">
                    fal fa-repeat
                  </v-icon>
                </v-btn>
              </template>
              <span>Make default</span>
            </v-tooltip>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>
<style scoped>
.schedule-host-dropdown {
}
</style>
<script>
export default {
  props: ['fetchedHosts', 'game', 'setHostDate', 'date'],
  watch: {},
  data() {
    return {
      session: 1,
      selectedHost: ''
    }
  },
  mounted() {
  },
  methods: {
    setSession(event) {
      let sessionText = event.target.value;
      if (sessionText === "Choose Session") {
        this.session = 1;
      } else {
        this.session = sessionText.replace("Session ", "");
      }
      console.log("Setting session to" + this.session);
    },
    fullName(first, last) {
      return `${first} ${last}`
    },
    setHost() {
      console.log("Setting host for session:" + this.session);
      console.log(this.selectedHost);
      this.$emit('setHost', this.date, this.session, this.selectedHost.venueId, this.selectedHost.hostId, this.selectedHost.gameDate)
    },
    makeDefault() {
      this.$emit('makeDefault', this.selectedHost.calId, this.session, this.selectedHost.venueId, this.selectedHost.hostId)
    },
    countStime(venue) {
      let count = 0
      if (venue.hasOwnProperty('stime1') && venue.stime1) count++
      if (venue.hasOwnProperty('stime2') && venue.stime2) count++
      if (venue.hasOwnProperty('stime3') && venue.stime3) count++
      if (venue.hasOwnProperty('stime4') && venue.stime4) count++
      return count
    }
  }
}
</script>